//import React from 'react';

import { makeStyles } from '@mui/styles';

export const useStyle = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    pointerEvents: 'none',
    userSelect: 'none',
    transition: 'opacity linear 0.1s',
    opacity: 0,
    
    boxShadow: '0 1px 6px 3px rgba(0, 0, 0, 0.1)',
    borderRadius: '0.25rem',
    margin: '0.5rem 0',
    
    zIndex: 1500
  },
  
  visible: {
    opacity: 1,
    
    '& $item': {
      pointerEvents: 'all'
    }
  },
  
  hint: {
    fontSize: '0.8em',
    fontWeight: 500,
    color: '#999',
    
    padding: '0.05rem 0.5rem'
  },
  
  list: {
    listStyle: 'none',
    
    margin: 0,
    padding: 0
  },
  
  item: {
    fontSize: '0.9em',
    
    cursor: 'pointer',
    padding: '0.25rem 0.5rem',
    
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    },
    
    '&.active': {
      backgroundColor: theme.palette.action.selected
    }
  }
}));
